<template>
  <!-- AOS ставит на анимируемый элемент transform: none и перебивает подъём
       по ховеру, поэтому появление и ховер разведены по разным элементам -->
  <div class="w-full min-w-350p md:min-w-250p sm:w-1/3 lg:w-1/4" data-aos="fade-up">
    <div class="card h-full bg-white rounded-45p border border-gray-200 shadow-xl dark:bg-gray-800 dark:border-gray-700 px-6 py-6 cursor-pointer relative">
      <div class="flex flex-col items-start pb-4 gap-3">
        <div class="flex justify-between w-full">
          <slot name="icon"/>
          <div class="arrow bg-hover-arrow bg-no-repeat bg-contain w-12 h-12 opacity-100 md:opacity-0"/>
        </div>

        <div class="w-full text-left text-20 text-navy font-bold">
          <slot name="title"/>
        </div>
        <div class="text-16 text-gray-500 font-normal text-left">
          <slot name="description"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpYourBusinessCart'
}
</script>

<style scoped>
  .card {
    transition: border-color .3s ease, box-shadow .3s ease, transform .3s ease;
  }

  .card:hover {
    border-color: #FFCE1F;
    transform: translateY(-6px);
    box-shadow: 0 22px 40px rgba(4, 23, 41, .16);
  }

  /* переход объявлен на самой стрелке, иначе она исчезает рывком,
     когда курсор уходит с карточки */
  .arrow {
    transition: opacity .3s ease, transform .3s ease;
  }

  .card:hover .arrow {
    opacity: 1;
    transform: translateX(4px);
  }

  @media (prefers-reduced-motion: reduce) {
    .arrow,
    .card {
      transition: none;
    }

    .card:hover {
      transform: none;
    }
  }
</style>
